/** Every working screen sits behind this gate (`@/lib/session`). */
import { Navigate, Outlet, useLocation } from "react-router";
import { ErrorState, Loading } from "@/components/page";
import { isSignedOut, signInHref, useSession } from "@/lib/session";

export function RequireSession() {
  const session = useSession();
  const location = useLocation();
  if (session.isPending) {
    return (
      <div className="mx-auto w-full max-w-[80rem] px-12 pt-8 max-lg:px-6 max-sm:px-4">
        <Loading />
      </div>
    );
  }
  if (session.isError) {
    if (isSignedOut(session.error)) return <Navigate to={signInHref(location)} replace />;
    return (
      <main className="mx-auto max-w-xl p-6">
        <ErrorState error={session.error} onRetry={() => void session.refetch()} />
      </main>
    );
  }
  return <Outlet />;
}
